import TrezorConnect, { UI_EVENT } from 'trezor-connect'

const TREZOR_APP_MANIFEST_EMAIL = 'support@binance.org'
const TREZOR_APP_MANIFEST_URL = 'https://www.binance.org'

// connect to localhost if on localhost.
if (window.location.host.includes('localhost')) {
  window.__TREZOR_CONNECT_SRC = 'https://localhost:8088/'
}

TrezorConnect.on(UI_EVENT, ev => {
  console.debug('Trezor Event!', ev)
})

export default function init() {
  try {
    TrezorConnect.manifest({
      email: TREZOR_APP_MANIFEST_EMAIL,
      appUrl: TREZOR_APP_MANIFEST_URL,
    })
  } catch (err) {
    console.warn('Trezor Connect manifest() failed', err)
  }
}
